import { closest15minutes, DATE_PARSE_FORMAT } from '@utils'
import { DateUtil } from '@utils/dateUtil'

type DisabledTimeParamsT = {
  timeFromList: DateUtil[]
  timeToList: DateUtil[]
  bookedTimes?: DateUtil[]
  timezone: string
  startTime: DateUtil
  endTime: DateUtil
  bookingWorkdayTimeFrom: string
  bookingWorkdayTimeTo: string
}

export const getDisabledOptionsIndexes = ({
  timeFromList,
  timeToList,
  bookedTimes = [],
  timezone,
  startTime,
}: DisabledTimeParamsT): { disabledFrom: number[]; disabledTo: number[] } => {
  const now = closest15minutes(DateUtil.tz(timezone))
  const disabledFrom: number[] = []
  const disabledTo: number[] = []
  const formattedBookedTimes = bookedTimes.map((b) => b.format(DATE_PARSE_FORMAT))
  for (let i = 0; i < timeFromList.length; i++) {
    if (
      now.isAfter(timeFromList[i]) ||
      formattedBookedTimes.includes(timeFromList[i].format(DATE_PARSE_FORMAT))
    ) {
      disabledFrom.push(i)
    }
  }

  for (let j = 0; j < timeToList.length; j++) {
    if (
      now.isAfter(timeToList[j]) ||
      startTime.isAfter(timeToList[j]) ||
      formattedBookedTimes.includes(timeToList[j].format(DATE_PARSE_FORMAT))
    ) {
      disabledTo.push(j)
    }
  }

  return { disabledFrom, disabledTo }
}
